import { Suspense } from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import Loader from "../components/Loader";
import routes from "./routes";
import ProtectedRoute from "./ProtectedRoute";
import ResponsiveComponent from "../components/common/ResponsiveComponent";
import SessionManager from "../components/sessionManager/SessionManager";

const generateRoutes = (routes) => {
  return routes.map(
    ({
      type,
      component: Component,
      mobileComponent: MobileComponent,
      ib,
      children,
      ...rest
    }) => {
      const ComponentToRender = MobileComponent
        ? () => (
            <ResponsiveComponent
              mobileComponent={MobileComponent}
              desktopComponent={Component}
            />
          )
        : Component;

      return {
        element: (
          <ProtectedRoute type={type} ib={ib} {...rest}>
            <ComponentToRender />
          </ProtectedRoute>
        ),
        children: children?.length ? generateRoutes(children) : null,
        ...rest,
      };
    }
  );
};

const RoutesWrapper = () => {
  return useRoutes(generateRoutes(routes));
};

const AppRoutes = () => {
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <RoutesWrapper />
      </Suspense>

      <SessionManager />
    </Router>
  );
};

export default AppRoutes;
